import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { NgZorroAntModule } from 'vhobjects-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { RouterModule } from '@angular/router';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
export function playerFactory() {
  return player;
}
import { VhFB_OTP } from 'vhmongo-new';
import { MaterialModule } from 'vhobjects-service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

import { AtwButtonConfig } from './objects/basic/button/config/config-button/config-button.component';

import { AtwImageConfig } from './objects/basic/image/config/image-config.component';

import { AtwIconConfig } from './objects/basic/icon/config/icon-config/icon-config.component';
import { AtwMapConfig } from './objects/basic/map/config/map-config.component';

import { AtwNumberCountingConfig } from './objects/basic/number-counting/config/number-counting-config.component';
import { AtwShapeConfig } from './objects/basic/shape/config/shape-config/shape-config.component';
import { AtwTextConfig } from './objects/basic/text/config/text-config.component';
import { AtwVideoConfig } from './objects/basic/video/config/video-config.component';
import { AtwSearchConfig } from './objects/basic/search/config/search-config/search-config.component';
import { AtwPopupConfig } from './objects/basic/popup/config/popup-config/popup-config.component';
import { AtwHoverConfig } from './objects/basic/hover/config/hover-config/hover-config.component';

import { AtwImageCategoryConfig } from './objects/category/image-category/config/image-category-config/image-category-config.component';

import { AtwTextCategotyNameConfig } from './objects/category/text-category-name/config/text-categoty-name-config/text-categoty-name-config.component';
import { AtwDatePostedNewsConfig } from './objects/news/date-posted-news/config/date-posted-news-config.component';
import { AtwTextNewsTitleConfig } from './objects/news/text-news-title/config/text-news-title-config.component';
import { AtwViewersNewsConfig } from './objects/news/viewers-news/config/viewers-news-config/viewers-news-config.component';
import { AtwButtonQuantityConfig } from './objects/product/button-quantity/config/button-config-quantity.component';
import { AtwButtonViewDetailConfig } from './objects/product/button-view-detail/config/button-view-detail-config/button-view-detail-config.component';
import { AtwImageDetailConfig } from './objects/product/image-detail/config/image-detail-config/image-detail-config.component';
import { AtwImageProductConfig } from './objects/product/image-product/config/image-product-config.component';
import { AtwSortProductConfig } from './objects/product/sort-product/config/sort-product-config.component';
import { AtwTextBrandConfig } from './objects/product/text-brand/config/text-brand-config.component';
import { AtwTextDiscountConfig } from './objects/product/text-discount/config/text-discount-config.component';
import { AtwTextNameConfig } from './objects/product/text-name/config/text-name-config.component';
import { AtwTextPriceConfig } from './objects/product/text-price/config/text-price-config.component';
import { AtwTextPriceSaleConfig } from './objects/product/text-price-sale/config/text-price-sale-config.component';
import { AtwTextShortDescriptionConfig } from './objects/product/text-short-description/config/text-short-description-config.component';
import { ImageDetailConfigImageComponent } from './objects/product/image-detail/config/image-detail-config-image/image-detail-config-image.component';

import { AtwCountdownConfig } from './objects/basic/countdown/config/countdown-config.component';
import { CountDownConfigDesktopComponent } from './objects/basic/countdown/config/config-desktop/config-desktop.component';
import { CountDownConfigMobileComponent } from './objects/basic/countdown/config/config-mobile/config-mobile.component';
import { AtwCountdownProductConfig } from './objects/product/countdown/config/countdown-config.component';
import { CountDownProductConfigMobileComponent } from './objects/product/countdown/config/config-mobile/config-mobile.component';
import { CountDownProductConfigDesktopComponent } from './objects/product/countdown/config/config-desktop/config-desktop.component';
import { AtwPopupDetailConfig } from './objects/product/popup-detail/config/popup-detail-config/popup-detail-config.component';
import { AtwUnitsConfig } from './objects/product/units/config/units-config/units-config.component';

import { AtwRangePriceConfig } from './objects/product/range-price/config/range-price-config/range-price-config.component';
import { AtwTextCollapseConfig } from './objects/basic/text-collapse/config/text-collapse-config/text-collapse-config.component';
import { AtwInputEmailConfig } from './objects/form/input-email/config/input-email-config.component';
import { AtwInputPasswordConfig } from './objects/form/input-password/config/input-password-config.component';
import { AtwInputTelephoneConfig } from './objects/form/input-telephone/config/input-telephone-config.component';
import { AtwInputNameConfig } from './objects/form/input-name/config/input-name-config.component';
import { AtwInputAddressConfig } from './objects/form/input-address/config/input-address-config.component';
import { AtwInputContentConfig } from './objects/form/input-content/config/input-content-config.component';
import { AtwUserNameConfig } from './objects/form/user-name/config/user-name-config.component';
import { AtwButtonLogoutConfig } from './objects/form/button-logout/config/button-logout-config.component';

import { AtwPopupOpenFormConfig } from './objects/form/popup-open-form/config/popup-open-form-config.component';
import { AtwMenuCategoryConfig } from './objects/category/menu-category/config/menu-category-config.component';
import { AtwMenuProductConfig } from './objects/product/menu-product/config/menu-product-config/menu-product-config.component'
import { AtwFeeConfig } from './objects/cart/fee/config/fee-config/fee-config.component';
import { AtwButtonShowModalConfig } from './objects/basic/button-show-modal/config/button-show-modal-config/button-show-modal-config.component';
import { AtwInputNewPasswordConfig } from './objects/form/input-new-password/config/input-new-password-config.component';
import { AtwInputConfirmPasswordConfig } from './objects/form/input-confirm-password/config/input-confirm-password-config.component';
import { AtwMessengerConfig } from './objects/difference/messenger/config/messenger-config.component';

import { AtwButtonQuantityCartConfig } from './objects/cart/button-quantity-cart/config/button-quantity-cart-config.component';
import { AtwTotalPriceBillConfig } from './objects/bill/total-price-bill/config/total-price-bill-config/total-price-bill-config.component';
import { AtwDateBillConfig } from './objects/bill/date-bill/config/date-bill-config/date-bill-config.component';
import { AtwBillCodeConfig } from './objects/bill/bill-code/config/bill-code-config/bill-code-config.component';
import { AtwZaloShareConfig } from './objects/difference/zalo-share/config/config-button/zalo-share-config-button.component';
import { AtwZaloFollowConfig } from './objects/difference/zalo-follow/config/config-button/zalo-follow-config-button.component';
import { AtwButtonPreviewConfig } from './objects/website/button-preview/config/button-preview-config/button-preview-config.component';
import { AtwButtonPreviewImageConfig } from './objects/website/button-preview-image/config/button-preview-image-config/button-preview-image-config.component';
import { AtwAnimateConfigButton } from './objects/difference/animate-button/config/config-button/animate-config-button.component';
import { AtwDateUpdateConfig } from './objects/website/date-update/config/date-update-config/date-update-config.component';
import { AtwQuantitySoldConfig } from './objects/website/quantity_sold/config/quantity-sold-config/quantity-sold-config.component';
import { AtwWebsiteVersionConfig } from './objects/website/version/config/website-version-config/website-version-config.component';
import { VhStringPercentPipeModule } from './vhstringpercent.pipe';
import { AtwLineConfig } from './objects/basic/line/config/line-config/line-config.component';
import { AtwMenuHorizontalConfig } from './objects/menu/menu-horizontal/config/menu-horizontal-config/menu-horizontal-config.component';
import { AtwMenuVerticalConfig } from './objects/menu/menu-vertical/config/menu-vertical-config/menu-vertical-config.component';
import { AtwTextExpireConfig } from './objects/product/text-expire/config/text-expire-config/text-expire-config.component';
import { AtwNoteBillConfig } from './objects/cart/note-bill/config/note-bill-config/note-bill-config.component';
import { AtwNoteProductConfig } from './objects/cart/note-product/config/note-product-config/note-product-config.component';

import { AtwCheckBoxChooseProductConfig } from './objects/cart/check-box-choose-product/config/check-box-choose-product-config/check-box-choose-product-config.component';
import { AtwSendCVConfig } from './objects/recruitment/button-send-CV/config/send-CV-config/send-CV-config.component';
import { AtwUploadFileConfig } from './objects/recruitment/upload-file/config/upload-file-config/upload-file-config.component';
import { AtwPaymentCartConfig } from './objects/cart/payment-cart/config/payment-cart-config/payment-cart-config.component';
import { AtwTextDiscountValueConfig } from './objects/product/text-discount-value/text-discount-value-config/text-discount-value-config.component';

import { AtwTextParagraphConfig } from './objects/basic/text-paragraph/config/text-paragraph-config/text-paragraph-config.component';
import { AtwPdfViewerConfig } from './objects/basic/pdf-viewer/config/pdf-viewer-config.component';
import { DynamicModule } from 'ng-dynamic-component';
import { AtwBtnLoginLogout2StatesConfig } from './objects/form/btn-login-logout-2states/config/btn-login-logout-2states-config/btn-login-logout-2states-config.component';
import { AtwSelectAddressConfig } from './objects/basic/select-address/config/select-address-config/select-address-config.component';
import { VhVirtualPositionConfigComponent } from './objects/vh-virtual-position/config/vh-virtual-position-config/vh-virtual-position-config.component';
import { TranslateModule } from '@ngx-translate/core';
import { AtwOrdinalRecruitmentConfig } from './objects/recruitment/ordinal-recruitment/config/ordinal-recruitment-config/ordinal-recruitment-config.component';
import { AtwFavoriteConfig } from './objects/product/favorite/config/favorite-config/favorite-config.component';
import { AtwImageRepeatConfig } from './objects/basic/image-repeat/config/image-repeat-config.component';
import { AtwTextRepeatConfig } from './objects/basic/text-repeat/config/text-repeat-config/text-repeat-config.component';
import { AtwDynamicFilterConfig } from './objects/product/dynamic-filter/config/dynamic-filter-config/dynamic-filter-config.component';
import { AtwBreadcrumbConfig } from './objects/basic/breadcrumb/config/config-breadcrumb/config-breadcrumb.component';
import { AtwButtonSearchSnimeiConfig } from './objects/sn-imei/button-search-snimei/config/button-search-snimei-config/button-search-snimei-config.component';
import { AtwSearchSnimeiConfig } from './objects/sn-imei/search-snimei/config/search-snimei-config/search-snimei-config.component';
import { DescriptionRecruitmentConfigComponent } from './objects/recruitment/description-recruitment/config/description-recruitment-config/description-recruitment-config.component';
import { AtwDateDeliveryConfig } from './objects/cart/date-delivery/config/date-delivery-config/date-delivery-config.component';
import { AtwExportBillConfig } from './objects/cart/export-bill/config/export-bill-config/export-bill-config.component';
import { AtwRemainingTimeConfig } from './objects/sn-imei/remaining-time/config/remaining-time-config/remaining-time-config.component';
import { AtwButtonActiveConfig } from './objects/sn-imei/button-active/config/button-active-config/button-active-config.component';
import { AtwNewFieldSnimeiConfig } from './objects/sn-imei/new-field-snimei/config/new-field-snimei-config/new-field-snimei-config.component';
import { AtwVideoUploadConfig } from './objects/basic/video-upload/config/video-upload/video-upload.component';
import { AtwImageVideoDetailConfig } from './objects/product/image-video-detail/config/image-video-detail-config/image-video-detail-config.component';
import { AtwImageVideoDetailConfigImage } from './objects/product/image-video-detail/config/image-video-detail-config-image/image-video-detail-config-image.component';
import { AtwActiveDateConfig } from './objects/sn-imei/active-date/config/active-date-config/active-date-config.component';
import { AtwPopupInteractiveConfig } from './objects/product/popup-interactive/config/popup-interactive-config/popup-interactive-config.component';
import { AtwCustomizeObjectConfig } from './objects/basic/customize-object/config/customize-object-config.component';
import { AtwImageBeforeAfterSliderConfig } from './objects/basic/image-before-after-slider/config/image-before-after-slider-config/image-before-after-slider-config.component';
import { IonicModule } from '@ionic/angular';
import { AtwChooseSubproductConfig } from './objects/product/choose-subproduct/config/choose-subproduct-config/choose-subproduct-config.component';
import { AtwButtonFavoriteConfig } from './objects/product/button-favorite/config/button-favorite-config/button-favorite-config.component';
import { AtwNewFieldCkeditorConfig } from './objects/product/newField-ckeditor/config/newField-ckeditor-config/newField-ckeditor-config.component';
import { AtwTableOfContentConfig } from './objects/news/table-of-content/config/table-of-content-config.component';
import { VhLanguagePipeModule } from './vh-language.pipe';
import { AtwTextActiveConfig } from './objects/sn-imei/text-active/config/text-active-config.component';
import { AtwMultiLanguageConfig } from './objects/basic/multi-language/config/multi-language-config/multi-language-config.component';
import { AtwButtonRepeatConfig } from './objects/basic/button-repeat/config/button-repeat-config/button-repeat-config.component';
import { AtwDisplayPropertyConfig } from './objects/foods/display-property/config/display-property-config/display-property-config.component';
import { AtwChoosePropertyConfig } from './objects/foods/choose-property/config/choose-property-config/choose-property-config.component';
import { AtwButtonShowModalDetailConfig } from './objects/foods/button-show-modal-detail/config/button-show-modal-detail-config/button-show-modal-detail-config.component';
import { CustomizeNewFieldConfigModule } from './objects/product/customize-newField/config/customize-newField-config/customize-newField-config.module';
import { AtwFlipBookConfig } from './objects/basic/flip-book/config/flip-book-config.component';
import { AtwConfigProfileUser } from './objects/profiles/profile-user/config/profile-user-config/config-profile-user.component';
import { AtwProfileWebsiteConfig } from './objects/profile-website/config/profile-website-config/profile-website-config.component';

import { TextFormatConfigModule } from 'vhobjects-service';
import { HideShowConfigModule } from 'vhobjects-service';
import { LetterSpacingConfigModule } from 'vhobjects-service';
import { LineHeightConfigModule } from 'vhobjects-service';
import { TextStyleConfigModule } from 'vhobjects-service';
import { LinkPageModule } from 'vhobjects-service';
import { ShadowConfigModule } from 'vhobjects-service';
import { SymbolConfigModule } from 'vhobjects-service';
import { ObjectFitConfigModule } from 'vhobjects-service';
import { DataAdminManagementConfigModule } from 'vhobjects-service';
import { PositionOutConfigModule } from 'vhobjects-service';
import { WidthHeightConfigModule } from 'vhobjects-service';
import { RotateConfigModule } from 'vhobjects-service';
import { PaddingConfigModule } from 'vhobjects-service';
import { FilterConfigModule } from 'vhobjects-service';
import { BrightnessContrastConfigModule } from 'vhobjects-service';
import { TimeFormatConfigModule } from 'vhobjects-service';
import { TotalRowColProductsConfigModule } from 'vhobjects-service';
import { SlideConfigModule } from 'vhobjects-service';
import { IconLeftConfigModule } from 'vhobjects-service';
import { IconRightConfigModule } from 'vhobjects-service';
import { PositionInVirtualConfigModule } from 'vhobjects-service';
import { PositionOutVirtualConfigModule } from 'vhobjects-service';
import { MarginConfigModule } from 'vhobjects-service';
import { PositionInConfigModule } from 'vhobjects-service';
import { ImageUploadConfigModule } from 'vhobjects-service';
import { ImageUploadOptionConfigModule } from 'vhobjects-service';
import { BackgroundImageConfigModule } from 'vhobjects-service';
import { BordersConfigModule } from 'vhobjects-service';
import { AnimationsConfigModule } from 'vhobjects-service';
import { ChooseAnimationsConfigModule } from 'vhobjects-service';
import { BordersRadiusConfigModule } from 'vhobjects-service';
import { LanguageService } from 'vhobjects-service/src/services';

import { AtwFrameBannerConfig } from './frames/frame-banner/config/frame-banner-config/frame-banner-config.component';
import { AtwFrameBlankConfig } from './frames/frame-blank/config/frame-blank-config/frame-blank-config.component';
import { AtwFrameCategoriesConfig } from './frames/frame-categories/config/frame-categories-config/frame-categories-config.component';
import { AtwFrameNewsGroupConfig } from './frames/frame-news-group/config/frame-news-group-config/frame-news-group-config.component';
import { AtwFrameProductByCategoryConfig } from './frames/frame-product-by-category/config/frame-product-by-category-config/frame-product-by-category-config.component';
import { AtwFrameProductsConfig } from './frames/frame-products/config/frame-products-config/frame-products-config.component';
import { AtwFrameCategoryDetailConfig } from './frames/frame-category-detail/config/frame-category-detail-config/frame-category-detail-config.component';
import { AtwFrameProductDetailConfig } from './frames/frame-product-detail/config/frame-product-detail-config/frame-product-detail-config.component';
import { AtwFrameCartProductsConfig } from './frames/frame-cart-products/config/frame-cart-products-config/frame-cart-products-config.component';
import { AtwFrameSearchByKeywordConfig } from './frames/frame-search-by-keyword/config/frame-search-by-keyword-config/frame-search-by-keyword-config.component';
import { AtwFrameCollapseConfig } from './frames/frame-collapse/config/frame-collapse-config/frame-collapse-config.component';
import { AtwFrameTabsConfig } from './frames/frame-tabs/config/frame-tabs-config/frame-tabs-config.component';
import { AtwSearchCustomizeConfig } from './frames/search-customize/config/search-customize-config/search-customize-config.component';
import { AtwFrameResultConfig } from './frames/frame-result/config/frame-result-config/frame-result-config.component';
import { AtwFrameTab2StatesConfig } from './frames/frame-tab-2states/config/frame-tab-2states-config/frame-tab-2states-config.component';
import { AtwFrameProductsViewedConfig } from './frames/frame-products-viewed/config/frame-products-viewed-config/frame-products-viewed-config.component';
import { AtwFrameSnimeiDetailConfig } from './frames/frame-snimei-detail/config/frame-snimei-detail-config/frame-snimei-detail-config.component';
import { AtwFrameProductByCategoryViewMoreConfig } from './frames/frame-product-by-category-view-more/config/frame-product-by-category-view-more-config/frame-product-by-category-view-more-config.component';
import { AtwFrameCommentConfig } from './frames/frame-comment/config/frame-comment-config/frame-comment-config.component';
import { AtwFrameRepliedConfig } from './frames/frame-replied/config/frame-replied-config/frame-replied-config.component';
import { AtwFrameReplyCommentConfig } from './frames/frame-reply-comment/config/frame-reply-comment-config/frame-reply-comment-config.component';
import { AtwFrameRoomByCategoryConfig } from './frames/frame-room-by-category/config/frame-room-by-category-config.component';
import { AtwFrameRoomByCategoryViewMoreConfig } from './frames/frame-room-by-category-view-more/config/frame-room-by-category-view-more-config.component';

import { AtwRateConfig } from './objects/product/rate/config/rate-config.component';
import { AtwDateRepeatConfig } from './objects/basic/date-repeat/config/date-repeat-config.component';
import { AtwInputCalculateCustomConfig } from './objects/form/input-calculate-custom/config/input-calculate-custom-config.component';
import { AtwSharingSocialConfig } from './objects/news/sharing-social/config/sharing-social-config.component';
import { AtwBarcodeConfig } from './objects/product/barcode/config/barcode-config/barcode-config.component';
import { AtwCategoryProductConfig } from './objects/product/category-product/config/category-product-config.component';
import { AtwDateCreateProductConfig } from './objects/product/date-create-product/config/date-create-product-config.component';
import { AtwSelectConfig } from './objects/form/select/config/select-config/select-config.component';
import { AtwMapRepeatConfig } from './objects/basic/map-repeat/config/map-repeat-config.component';
import { AtwTextAvailabilityConfig } from './objects/product/text-availability/config/text-availability-config.component'
import { AtwVideoRepeatConfig } from './objects/basic/video-repeat/config/video-repeat-config/video-repeat-config.component';
import { AtwRadioPaymentMethodConfig } from './objects/cart/radio-payment-method/config/radio-payment-method-config/radio-payment-method-config.component';
import { AtwEditImage } from './objects/basic/image/edit-image/edit-image.component';
import { AtwPopupRepeatConfig } from './objects/basic/popup-repeat/config/popup-repeat-config/popup-repeat-config.component';
import { ColorContrastComponent } from './color-contrast/color-contrast.component';
import { EditShapeComponent } from './objects/basic/shape/config/edit-shape/edit-shape.component';
import { AtwReviewConfig } from './objects/review/config/review-config/review-config.component';
import { AtwImageDetailRepeatConfig } from './objects/basic/image-detail-repeat/config/image-detail-repeat-config/image-detail-repeat-config.component';
import { AtwListOrderConfig } from './objects/cart/list-order/config/list-order-config/list-order-config.component';
import { AtwTabBarConfig } from './objects/basic/tab-bar/config/tab-bar-config.component';
import { AtwContentPreviewSliderConfig } from './objects/basic/content-preview-slider/config/content-preview-slider-config/content-preview-slider-config.component';
import { AtwTextConnectorRowRepeatConfig } from './objects/basic/text-connector-row-repeat/config/text-connector-row-repeat-config/text-connector-row-repeat-config.component';
const component = [
  AtwFrameBannerConfig,
  AtwFrameBlankConfig,
  AtwFrameCategoriesConfig,
  AtwFrameNewsGroupConfig,
  AtwFrameProductByCategoryConfig,
  AtwFrameProductsConfig,
  AtwFrameSearchByKeywordConfig,

  AtwFrameCategoryDetailConfig,
  AtwFrameProductDetailConfig,
  AtwFrameCartProductsConfig,

  AtwFrameCollapseConfig,
  AtwFrameTabsConfig,
  AtwFrameProductsViewedConfig,  

  AtwSearchCustomizeConfig,
  AtwFrameResultConfig,
  AtwFrameTab2StatesConfig,
  AtwFrameSnimeiDetailConfig,
  AtwFrameProductByCategoryViewMoreConfig,
  AtwFrameCommentConfig,
  AtwFrameRepliedConfig,
  AtwFrameReplyCommentConfig,
  AtwFrameRoomByCategoryConfig,
  AtwFrameRoomByCategoryViewMoreConfig,

  AtwTableOfContentConfig,
  AtwNewFieldCkeditorConfig,
  AtwButtonFavoriteConfig,
  AtwChooseSubproductConfig,
  AtwImageBeforeAfterSliderConfig,
  AtwCustomizeObjectConfig,
  AtwPopupInteractiveConfig,
  AtwActiveDateConfig,
  AtwImageVideoDetailConfig,
  AtwVideoUploadConfig,
  AtwNewFieldSnimeiConfig,
  AtwButtonActiveConfig,
  AtwRemainingTimeConfig,
  AtwExportBillConfig,
  AtwDateDeliveryConfig,
  DescriptionRecruitmentConfigComponent,
  AtwButtonSearchSnimeiConfig,
  AtwSearchSnimeiConfig,
  AtwTextRepeatConfig,
  AtwImageRepeatConfig,
  AtwButtonConfig,
  AtwImageConfig,
  AtwCountdownConfig,
  AtwIconConfig,
  AtwMapConfig,
  AtwNumberCountingConfig,
  AtwShapeConfig,
  AtwTextConfig,
  AtwVideoConfig,
  AtwSearchConfig,
  AtwPopupConfig,
  AtwHoverConfig,
  AtwLineConfig,
  AtwTextCollapseConfig,
  AtwInputEmailConfig,
  AtwBtnLoginLogout2StatesConfig,
  AtwInputPasswordConfig,
  AtwInputTelephoneConfig,
  AtwInputNameConfig,
  AtwInputAddressConfig,
  AtwInputContentConfig,
  AtwButtonLogoutConfig,
  AtwUserNameConfig,
  AtwInputNewPasswordConfig,
  AtwInputConfirmPasswordConfig,
  AtwImageCategoryConfig,
  AtwMenuCategoryConfig,
  AtwTextCategotyNameConfig,
  AtwDatePostedNewsConfig,
  AtwTextNewsTitleConfig,
  AtwViewersNewsConfig,
  AtwButtonQuantityConfig,
  AtwButtonViewDetailConfig,
  AtwCountdownProductConfig,
  AtwImageDetailConfig,
  AtwImageProductConfig,
  AtwSortProductConfig,
  AtwTextBrandConfig,
  AtwTextDiscountConfig,
  AtwTextExpireConfig,
  AtwTextNameConfig,
  AtwTextPriceConfig,
  AtwTextPriceSaleConfig,
  AtwTextShortDescriptionConfig,
  AtwUnitsConfig,
  AtwPopupDetailConfig,
  AtwRangePriceConfig,
  AtwMenuProductConfig,
  AtwCheckBoxChooseProductConfig,
  AtwButtonQuantityCartConfig,
  AtwPopupOpenFormConfig,
  AtwFeeConfig,
  AtwTextDiscountValueConfig,
  AtwMenuHorizontalConfig,
  AtwMenuVerticalConfig,
  AtwButtonShowModalConfig,
  AtwMessengerConfig,
  AtwZaloShareConfig,
  AtwZaloFollowConfig,
  AtwTotalPriceBillConfig,
  AtwDateBillConfig,
  AtwBillCodeConfig,
  AtwPaymentCartConfig,
  AtwButtonPreviewConfig,
  AtwButtonPreviewImageConfig,
  AtwDateUpdateConfig,
  AtwAnimateConfigButton,
  AtwQuantitySoldConfig,
  AtwWebsiteVersionConfig,
  AtwNoteBillConfig,
  AtwNoteProductConfig,
  AtwSendCVConfig,
  AtwUploadFileConfig,
  AtwTextParagraphConfig,
  AtwPdfViewerConfig,
  AtwSelectAddressConfig,
  VhVirtualPositionConfigComponent,
  AtwFavoriteConfig,
  AtwDynamicFilterConfig,
  AtwBreadcrumbConfig,
  AtwTextActiveConfig,
  AtwMultiLanguageConfig,
  AtwButtonRepeatConfig,
  AtwDisplayPropertyConfig, AtwChoosePropertyConfig, AtwButtonShowModalDetailConfig,
  AtwFlipBookConfig,
  AtwConfigProfileUser,
  AtwProfileWebsiteConfig,
  AtwRateConfig,
  AtwDateRepeatConfig,
  AtwMapRepeatConfig,
  AtwInputCalculateCustomConfig,
  AtwSharingSocialConfig,
  AtwBarcodeConfig,
  AtwCategoryProductConfig,
  AtwDateCreateProductConfig,
  AtwSelectConfig,
  AtwOrdinalRecruitmentConfig,
  AtwTextAvailabilityConfig,
  AtwVideoRepeatConfig,
  AtwRadioPaymentMethodConfig,
  AtwPopupRepeatConfig,
  AtwReviewConfig,
  AtwImageDetailRepeatConfig,
  AtwListOrderConfig,
  AtwTabBarConfig,
  AtwContentPreviewSliderConfig,
  AtwTextConnectorRowRepeatConfig
]

@NgModule({
  declarations: [component,
    CountDownConfigDesktopComponent, CountDownConfigMobileComponent,
    CountDownProductConfigDesktopComponent, CountDownProductConfigMobileComponent,
    AtwImageVideoDetailConfigImage,
    ImageDetailConfigImageComponent,
    AtwEditImage,
    ColorContrastComponent,
    EditShapeComponent,
    
  ],
  entryComponents: [component],
  imports: [
    CommonModule,
    FormsModule,
    NgZorroAntModule,
    ReactiveFormsModule,
    RouterModule,
    LottieModule.forRoot({ player: playerFactory }),
    MaterialModule,
    CKEditorModule,
    NgbCarouselModule,
    ColorPickerModule,
    VhStringPercentPipeModule,
    AnimationsConfigModule,
    PositionOutConfigModule,
    WidthHeightConfigModule,
    ChooseAnimationsConfigModule,
    DynamicModule,
    BordersRadiusConfigModule,
    HideShowConfigModule,
    BackgroundImageConfigModule,
    BordersConfigModule,
    BrightnessContrastConfigModule,
    ObjectFitConfigModule,
    SymbolConfigModule,
    ShadowConfigModule,
    TextFormatConfigModule,
    TextStyleConfigModule,
    FilterConfigModule,
    TotalRowColProductsConfigModule,
    SlideConfigModule,
    IconRightConfigModule,
    IconLeftConfigModule,
    DataAdminManagementConfigModule,
    PositionInVirtualConfigModule,
    PositionOutVirtualConfigModule,
    TranslateModule,
    LinkPageModule,
    MarginConfigModule,
    RotateConfigModule,
    LetterSpacingConfigModule,
    LineHeightConfigModule,
    ImageUploadConfigModule,
    ImageUploadOptionConfigModule,
    IonicModule,
    PaddingConfigModule,
    VhLanguagePipeModule,
    PositionInConfigModule,
    TimeFormatConfigModule,
    CustomizeNewFieldConfigModule
  ],
  exports: [component],
  providers: [LanguageService, VhFB_OTP]
})
export class VhObjectsConfigModule { }
